import { call, put, takeLatest } from 'redux-saga/effects'
import * as types from '../../../actions/index.types'
import { notify } from '../../../../utils/notification'
import * as req from '../../../../axios/request/SocietyController/CtrlProfileReqs/CtrlProfileReqs'


function* getProfile(action) {
    try {
        const result = yield call(req.getProfileReq, action);
        if (result.success === true) {
            notify('success', result.message);
            yield put({ type: types.CTRL_GET_PROFILE_SUCCESS, payload: result });
        } else {
            notify('error', result?.response?.data?.message || result?.message);
            yield put({ type: types.CTRL_GET_PROFILE_FAILURE, message: result?.response?.data?.message || result?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.CTRL_GET_PROFILE_FAILURE, message: e?.message });
    }
}
function* updateProfile(action) {
    try {
        const result = yield call(req.updateProfileReq, action);
        if (result.success === true) {
            notify('success', result.message);
            yield put({ type: types.CTRL_UPDATE_PROFILE_SUCCESS, payload: result });
        } else {
            notify('error', result?.response?.data?.message || result?.message);
            yield put({ type: types.CTRL_UPDATE_PROFILE_FAILURE, message: result?.response?.data?.message || result?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.CTRL_UPDATE_PROFILE_FAILURE, message: e?.message });
    }
}
function* changePassword(action) {
    try {
        const result = yield call(req.changePasswordReq, action);
        if (result.success === true) {
            notify('success', result.message);
            yield put({ type: types.CTRL_CHANGE_PASSWORD_SUCCESS, payload: result });
        } else {
            notify('error', result?.response?.data?.message || result?.message);
            yield put({ type: types.CTRL_CHANGE_PASSWORD_FAILURE, message: result?.response?.data?.message || result?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.CTRL_CHANGE_PASSWORD_FAILURE, message: e?.message });
    }
}





export default function* CtrlProfileSaga() {

    yield takeLatest(types.CTRL_GET_PROFILE, getProfile);
    yield takeLatest(types.CTRL_UPDATE_PROFILE, updateProfile);
    yield takeLatest(types.CTRL_CHANGE_PASSWORD, changePassword);
}
